import React, { Suspense, useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ActivityIndicator from "./components/ui/activityIndicator/ActivityIndicator";
import Login from "./pages/login/Login";
import AuthContext from "./components/context/AuthContext";
import Home from "./pages/homePage/Home";
import NavBar from "./components/ui/navigation/NavBar";
import CollectorADGroups from "./pages/collectorADGroups/CollectorADGroups";
import Crews from "./pages/crews/Crews";
import Collect from "./pages/collect/Collect";
import EditPhotoPointPhotos from "./pages/editPhotoPointPhotos/EditPhotoPointPhotos";
import SplicerAudit from "./pages/splicerAudit/SplicerAudit";
import SplicerAuditReport from "./pages/splicerAuditReport/SplicerAuditReport";
import PendingSplicerAudits from "./pages/pendingSplicers/PendingSplicerAudits";

function App() {
  const authCtx = useContext(AuthContext);

  let navigateToDefault = authCtx.isLoggedIn ? "/home" : "/login";
  let startScreenComponent = authCtx.isLoggedIn ? <Home /> : <Login />;

  const PrivateRoute = ({ children }) => {
    const authCtx = useContext(AuthContext);
    return authCtx.isLoggedIn ? children : <Navigate to="/login" />;
  };

  return (
    <React.Fragment>
      <Suspense fallback={<ActivityIndicator loading={true} />}>
        {authCtx.isLoggedIn && <NavBar />}
        <Routes>
          {/* Public Routes */}

          <Route path="/" element={startScreenComponent} />
          <Route path="/login" element={<Login />} />

          {/* Private Routes */}

          <Route
            path="/home"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/collect"
            element={
              <PrivateRoute>
                <Collect />
              </PrivateRoute>
            }
          />
          <Route
            path="/editPhotoPointPhotos"
            element={
              <PrivateRoute>
                <EditPhotoPointPhotos />
              </PrivateRoute>
            }
          />
          <Route
            path="/splicerAudit"
            element={
              <PrivateRoute>
                <SplicerAudit />
              </PrivateRoute>
            }
          />
          <Route
            path="/collectorADGroups"
            element={
              <PrivateRoute>
                <CollectorADGroups />
              </PrivateRoute>
            }
          />
          <Route
            path="/auditsPendingSplicers"
            element={
              <PrivateRoute>
                <PendingSplicerAudits />
              </PrivateRoute>
            }
          />
          <Route
            path="/crews"
            element={
              <PrivateRoute>
                <Crews />
              </PrivateRoute>
            }
          />
          <Route
            path="/splicerAuditReport"
            element={
              <PrivateRoute>
                <SplicerAuditReport />
              </PrivateRoute>
            }
          />
          {/* Default */}
          <Route path="*" element={<Navigate to={navigateToDefault} />} />
        </Routes>
      </Suspense>
    </React.Fragment>
  );
}

export default App;
